import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  app_runner_list: [],
  users_me: {},
  users: [],
  gstTaxRate: {},
  isLoading: false,
  showError: [],
  prefix: {},
  componentAttributes: {},
  menuProfileDetails: {}
};

const AppRunnerSlice: any = createSlice({
  name: "app_runner",
  initialState,
  reducers: {
    UsersMe: (state, action) => {
      state.users_me = action.payload;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setGstTaxRate: (state, action) => {
      state.gstTaxRate = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    showErrorModal: (state, action) => {
      state.showError = action.payload;
    },
    prefix: (state, action) => {
      state.prefix = action.payload;
    },
    setComponentAttributes: (state, action) => {
      state.componentAttributes = action.payload;
    },
    setMenuProfileDetails: (state, action) => {
      state.menuProfileDetails = action.payload;
    },
  },
});

export const { UsersMe, setUsers, setGstTaxRate, setLoading, showErrorModal, prefix, setComponentAttributes, setMenuProfileDetails } = AppRunnerSlice.actions;
export default AppRunnerSlice.reducer;
